import Store from "./store";
import { SearchItem } from './AorusHeader'
import EventEmitter from './EventEmitter'
import getPageMatrix from "./pageMatrix";

const pageMatrix = getPageMatrix(globalThis || window);
function vh(n) {
    return window.innerHeight * 0.01 * n;
}
function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date,
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}
function debounce(fn, wait) {
    var timeout;

    return function () {
        var self = this;
        var args = arguments;

        clearTimeout(timeout);

        return timeout = setTimeout(function () {

            timeout = null;
            fn.apply(self, args);

        }, wait);
    };
}
function toggleClass(dom, classname, bool) {
    if (typeof bool === "boolean") {
        if (bool) {
            dom.classList.add(classname);
        } else {
            dom.classList.remove(classname);
        }

        return;
    }

    if (dom.classList.contains(classname)) {
        dom.classList.remove(classname);
    } else {
        dom.classList.add(classname);
    }
}
function siblings(dom) {
    let result = [];
    let children = dom.parentElement.children;

    for (let i = 0; i < children.length; i++) {
        let child = children[i];
        if (child && child !== dom) {
            result.push(child);
        }
    }
    return result;
}
function getParent(dom, fn) {
    for (let parent = dom.parentElement; parent != null; parent = parent.parentElement) {
        let result = fn.call(null, parent);
        if (result) {
            return parent;
        }
    }

    return parent;
}
function hasClass(classname) {
    return (dom) => dom?.classList.contains(classname);
}
function removeClass(classname) {
    return (dom) => dom?.classList.remove(classname);
}

const resizeEmitter = (function resizeEvent() {
    const resizeQueue = [];

    function _resize() {
        resizeQueue.forEach(fn => fn && fn());
    }
    let resizeThrottle = throttle(_resize, 250);
    let resizeDebounce = debounce(_resize, 250);

    window.addEventListener('resize', e => {
        resizeThrottle();
        resizeDebounce();
    }, false);

    setTimeout(() => _resize(), 500);

    return {
        add(fn) {
            resizeQueue.push(fn);
            _resize();
        },
        emit: _resize
    }
})();
let isMobile = window.innerWidth < 960;
resizeEmitter.add(() => {
    isMobile = window.innerWidth < 960;
});

const domParser = new DOMParser();
class SearchHistory extends EventEmitter {
    key = '_search-history';
    maxDisplayResults = 5;

    constructor(container) {
        super();

        this.container = container;
        this.store = new Store();
        this.list = [];
        this.showlist = [];
        this.init();
    }
    get length() {
        return this.list.filter(text => text != null).length;
    }
    init() {
        const storeData = this.store.get(this.key) || [];

        this.add(...storeData);
    }
    remove(index) {
        this.list[index] = null;
        this.showlist[index].text = null;

        this._save();
        this._render();
    }
    add(...arr) {
        arr.forEach(text => {
            let index = this.list.indexOf(text);

            //先判斷是否有一樣的關鍵字
            if (index == -1) {
                //新增
                index = this.list.length
                this.list.push(text);

                const dom = domParser.parseFromString(SearchItem({ TranslateText: text }), 'text/html').body.children[0];
                const domClose = dom.querySelector('.search-history-delete');
                dom.addEventListener('click', e => {
                    this.emit('select', { text });
                    e.preventDefault();
                });
                domClose.addEventListener('click', e => {
                    this.remove(index);
                    e.preventDefault();
                    e.stopPropagation();
                });

                this.showlist[index] = { text, dom };
            } else {
                const tmp = this.showlist[index];
                this.showlist.splice(index, 1);
                this.showlist.push(tmp);
            }

        });

        this._save();
        this._render();
    }
    _save() {
        this.store.set(this.key, {
            data: this.list.filter(text => text != null),
            validTime: Store.Month(1)
        });
        this.store.save();
    }
    _render() {
        for (let i = this.showlist.length - 1, count = 0; i >= 0; i--) {
            const data = this.showlist[i];

            if (this.list[i] == null && this.container.contains(data.dom)) {
                this.container.removeChild(data.dom);
            }

            if (this.list[i] != null && count < this.maxDisplayResults) {
                this.container.appendChild(data.dom);
                count++;
            } else if (this.container.contains(data.dom)) {
                this.container.removeChild(data.dom);
            }
        }

        this.emit('render');
    }
}
class FlyoutHeader {
    constructor(header) {
        this.header = header;
        this.mobileTitle = header.querySelector('.header-mobile-subtitle');
        this.btnMenu = header.querySelector('.nav-menutrigger');
        this.btnSearch = header.querySelector('.btn-search');
        this.btnSearchClose = header.querySelector('.search-close');
        this.btnLogin = header.querySelector('.login-button');

        this.searchInput = header.querySelector('.seach-input')
        this.searchHistory = new SearchHistory(header.querySelector('.search-history-list'));

        this.isSearchOpen = false;
        this.isMenuOpen = false;

        this._scrollY = 0;
        this._lastScrollY = 0;
        this._direction = true;

        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.init();
    }
    init() {
        this.searchHistory.on('select', ({ text }) => {
            this.searchInput.value = text;
            this.searchInput.focus();
        });

        this.searchHistory.on('render', () => {
            if (this.searchHistory.length == 0) {
                this.header.querySelector('.header-search').classList.remove('show-history');
            }
            this.onResize();
        });

        //全局監聽點擊關閉
        document.addEventListener('click', e => {
            this.close();
        }, false);

        //prevent bubbling
        this.header.addEventListener('click', e => {
            e.stopPropagation();
        }, false);

        //手機menu按鈕動作
        this.btnMenu.addEventListener('click', e => {
            e.preventDefault();
            this.toggleMenu();
        }, false);

        //nav-menu事件
        this.header.querySelectorAll('.nav-menu .nav-submenu-trigger').forEach(dom => {
            dom.addEventListener('click', e => {
                const href = dom.getAttribute('href');
                const isLink = href != null && href != "";
                if (!isLink) {
                    e.preventDefault();

                    if (isMobile) {
                        this.onSubmenuTrigger(dom);
                    }
                }
            }, false);
            dom.addEventListener('mouseenter', e => {
                e.preventDefault();
                if (!isMobile) {
                    this.onSubmenuTrigger(dom, true);
                    this.header.classList.add('with-menu-open');

                    //初始第一項加上開啟的樣式
                    const menu = dom.parentElement.querySelector('.nav-submenu');
                    if (menu) {
                        const menulists = Array.from(menu.querySelectorAll('.nav-submenu-list')).filter(list => list.querySelector('.nav-submenu-list'));
                        menulists.forEach(menulist => {
                            const target = menulist.querySelector('.nav-submenu-list-item > .nav-submenu-trigger');
                            const parent = target?.parentNode;

                            parent?.classList.add('open');
                            siblings(parent).forEach(e => e.classList.remove('open'));
                        });
                    }
                }
            }, false);
        });

        //nav subtitle手機版事件
        this.mobileTitle.addEventListener('click', e => {
            toggleClass(this.header, 'with-submenu-open');
            this.header.querySelectorAll('.nav-submenu-list-item').forEach(dom => {
                dom.classList.remove('open');
            });
        });

        //nav pc版hover觸發
        let menuclosePC = debounce(e => {
            this.close();
        }, 250);
        let mcpcto = null;
        this.header.querySelectorAll('.nav-item').forEach(dom => {
            dom.addEventListener('mouseenter', e => {
                if (mcpcto) clearTimeout(mcpcto);
                if (isMobile) return;

                this.header.querySelectorAll('.right-item').forEach(removeClass('open'));

                const menu = dom.querySelector(':scope > .nav-submenu');
                const menuHeight = this.setMenuHeight(menu);
                this.setFlyoutHeight(menuHeight);

                dom.addEventListener('mouseleave', e => {
                    mcpcto = menuclosePC();
                }, { once: true });
            });
        });

        this.btnSearch.addEventListener('click', e => {
            e.preventDefault();

            this.isMenuOpen = false;
            this.isSearchOpen = !this.isSearchOpen;

            toggleClass(this.header, 'with-menu-open', false);

            if (this.isSearchOpen) {
                this.onSubmenuTrigger(this.btnSearch);

                toggleClass(this.header, 'with-search-open');
                toggleClass(document.body, "menu-open", isMobile);
            } else {
                this.close();
            }
        });

        this.searchInput.addEventListener('keypress', e => {
            const { key } = e;

            if (key == "Enter" && this.searchInput.value) {

                this.searchHistory.add(this.searchInput.value);
                this.showSearchHistory();

                requestAnimationFrame(() => {
                    window.location.href = searchUrl + this.searchInput.value;
                });
            }
        });

        this.searchInput.addEventListener('focus', e => {
            if (this.searchHistory.length) {
                this.showSearchHistory();
            }
        });

        //右側項目點擊觸發
        this.header.querySelectorAll('.right-submenu-trigger').forEach(dom => {
            dom.addEventListener('click', e => {
                e.preventDefault();
            });
        });
        this.btnSearchClose.addEventListener('click', e => {
            e.preventDefault();

            this.searchInput.value = "";
            this.searchInput.focus();
        });
        this.btnLogin.addEventListener('click', e => {
            toggleClass(this.btnLogin.parentElement, 'show-list');
        });

        resizeEmitter.add(this.onResize);

        //window.addEventListener('scroll', this.onScroll, false);
    }
    showSearchHistory() {
        this.header.querySelector('.header-search').classList.add('show-history');

        let parent = getParent(this.searchInput, hasClass('nav-submenu-content'));
        this.setFlyoutHeight(parent.offsetHeight);

        let submenu = getParent(this.searchInput, hasClass('nav-submenu'));
        this.setMenuHeight(submenu);
    }
    setMenuHeight(dom) {
        const groupContainer = dom.querySelector('.nav-submenu-group-container');


        const contents = isMobile ? [dom.querySelector('.nav-submenu-content')] : dom.querySelectorAll('.nav-submenu-content');
        const maxContentHeight = contents ? Math.max.apply(null, Array.from(contents).map((dom) => dom.offsetHeight).concat(0)) : 0;

        dom.style.setProperty('--r-nav-flyout-height', maxContentHeight + 'px');

        //AWSA-3 希望分隔線長度可以對齊左邊項目高度
        if (groupContainer) {
            groupContainer.style.setProperty('--r-nav-group-height', null);//歸0
            groupContainer.style.setProperty('--r-nav-group-height', groupContainer.offsetHeight + 'px');
        }

        return maxContentHeight;
    }
    onResize() {
        let maxHeight = 0;

        this.header.querySelectorAll('.nav-item').forEach(dom => {
            const menu = dom.querySelector(':scope > .nav-submenu');
            const menuHeight = this.setMenuHeight(menu);

            if (this.isMenuOpen) {
                this.setFlyoutHeight(Math.max(maxHeight, menuHeight));
            }
        });
        this.header.querySelectorAll('.right-item').forEach(dom => {
            const menu = dom.querySelector(':scope > .nav-submenu');
            const menuHeight = this.setMenuHeight(menu);

            if (this.isSearchOpen) {
                this.setFlyoutHeight(Math.max(maxHeight, menuHeight));
            }
        });

        //this.close();
    }
    onScroll() {
        this._lastScrollY = this._scrollY;
        this._scrollY = pageMatrix.y;
        this._direction = this._scrollY > this._lastScrollY;

        const hideHeader = this._direction && (this._scrollY != this._lastScrollY) && this._scrollY > vh(40);
        if (hideHeader) {
            this.header.classList.add('header-hide');
        } else {
            this.header.classList.remove('header-hide');
        }
    }
    close() {
        this.header.querySelectorAll('.nav-item, .right-item').forEach(removeClass('open'));
        this.header.classList.remove('with-search-open');
        this.header.classList.remove('with-submenu-open');
        this.header.classList.remove('with-menu-open');
        this.btnLogin.parentElement.classList.remove('show-list');

        this.isMenuOpen = false;
        this.isSearchOpen = false;

        this.setFlyoutHeight(0);
    }
    onSubmenuTrigger(dom, bool) {
        const parent = dom.parentElement;
        const silbings = siblings(parent);
        const menu = parent.querySelector(':scope > .nav-submenu');

        toggleClass(parent, 'open', bool);
        silbings.forEach(removeClass('open'));

        if (menu) {
            if (!isMobile) {
                //初始第一項加上開啟的樣式
                const menulists = Array.from(menu.querySelectorAll('.nav-submenu-list')).filter(list => list.querySelector('.nav-submenu-list'));
                menulists.forEach(menulist => {
                    const target = menulist.querySelector('.nav-submenu-list-item > .nav-submenu-trigger');
                    const parent = target?.parentNode;

                    parent?.classList.add('open');
                    siblings(parent).forEach(e => e.classList.remove('open'));
                });
            }

            //set height
            const height = this.setMenuHeight(menu);
            this.setFlyoutHeight(height);
        }

        if (parent.classList.contains('nav-submenu-list-item')) {
            toggleClass(this.header, "with-submenu-open", true);

            const title = dom.textContent.trim();
            this.mobileTitle.textContent = title;

            const submenu = parent.querySelector(':scope > .nav-submenu > .nav-scroll-container');
            if (submenu) {
                submenu.insertAdjacentElement('afterbegin', this.mobileTitle);
            }
        }
    }
    onSubmenuTriggerMobile(dom) {
        if (!isMobile) return;

        const parent = dom.parentElement;
        toggleClass(parent, "open");

        if (parent.classList.contains('nav-submenu-list-item')) {
            const submenu = parent.querySelector(':scope > .nav-submenu > .nav-scroll-container');
            const title = dom.textContent.trim();

            this.mobileTitle.textContent = title;

            if (submenu) {
                submenu.insertAdjacentElement('afterbegin', this.mobileTitle);
            }

            toggleClass(this.header, "with-submenu-open");
        }
    }
    setFlyoutHeight(height) {
        this.header.style.setProperty('--r-nav-max-content-height', height + 'px');
    }

    toggleMenu(bool) {
        //重置open狀態
        this.header.querySelectorAll('.nav-item, .nav-submenu-list-item').forEach(dom => {
            dom.classList.remove('open');
        });
        this.header.classList.remove('with-submenu-open');
        this.header.classList.remove('with-search-open');
        this.isSearchOpen = false;

        if (typeof bool === "boolean") {
            this.isMenuOpen = bool;
        } else {
            this.isMenuOpen = !this.isMenuOpen;
        }

        toggleClass(this.header, "with-menu-open", this.isMenuOpen);
        toggleClass(document.body, "menu-open", isMobile && this.isMenuOpen);
    }
}
class FlyoutFooter {
    constructor(container, data) {
        this.container = container;
        this.navGroups = this.container.querySelectorAll('.footer-nav-group');

        this.navGroups.forEach(item => {
            const trigger = item.querySelector('.footer-nav-title');

            trigger?.addEventListener('click', e => {
                let self = item;
                e.preventDefault();

                this.navGroups.forEach(item => {
                    if (item == self) {
                        toggleClass(item, 'open');
                    } else {
                        item.classList.remove('open');
                    }
                });
            });
        });

        this.onResize = this.onResize.bind(this);

        resizeEmitter.add(this.onResize);
    }
    onResize() {
        this.navGroups.forEach(item => {
            item.classList.remove('open');

            let target = item.querySelector('.footer-nav-submenu > ul');
            let n = target ? target.offsetHeight + 'px' : 'auto';
            item.style.setProperty('--nav-flyout-height', n);
        });
    }
}

export { FlyoutHeader, FlyoutFooter };